import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from "react-redux";
import './CoverflowBase.css'

import Coverflow from './Coverflow';
import Duration from './Duration';
import Waveform from './Waveform';

import CoverLink from '../common/CoverLink';
import CoverSplit from '../common/CoverSplit';
import Linkage from '../common/Linkage';
import JoinLinkage from '../common/JoinLinkage';

import {
  setTickItemID
} from "../../../actions/index";

function ConnectedCoverFlowContainer({
  playlists, active, clickItem,
  coverFlowStyle,
  isSubscribed
}) {
  const dispatch = useDispatch();
  const setTickItem = (id) => () => { dispatch(setTickItemID(`DI-${id}-TRACK`)) }
  const resize = (url) => url.replace(`105x105`, `210x210`); // IMG Default 250x250
  const clickable = false;

  return (
    <Coverflow key={playlists.from} width={coverFlowStyle.width} height={coverFlowStyle.height - 4} className={``}
      enableScroll={false}
      clickable={clickable}
      active={active}
    >
      { playlists.tracks.map( (track,i) => (
        <div key={`coverflow-${i}`} role="menuitem" style={{textAlign: `center`}} onClick={clickable ? clickItem(i) : null} >
          <div className={`cf-cover ${active === i && 'current'} ${!clickable && 'no-hover'}`}>
            { clickable && <div className={`oo`} /> }
            { active === i
              ? <CoverLink to={`/releases/${track.releaseID}/${track.id}`} alt={`cover-${track.id}`} src={resize(track.img)} />
              : <CoverSplit name={`cover-${track.id}`} images={[resize(track.img)]} size={`100%`} className={`display-block`} />
            }
          </div>
          <div className={`flexColumn cf-infos space-between`}>
            <div className={`flexColumn cf-data`}>
              {/* <div className={`flexRow space-between type-micro`}>
                <span className={`cf-state`}>{playlists.active === i && `Current Track`}&nbsp;</span>
              </div> */}
              <div className={`flexRow space-between type-regular cf-container-title`}>
                <Linkage className={`cf-title`} label={`${track.title} ${(track.mix_name !== '') ? ` - ${track.mix_name}` : null}`} to={playlists.from} callback={setTickItem(track.id)} />
                <div className={`cf-duration flexRow`}>
                  <span style={{width: 31}}>
                    { playlists.active === i || active === i 
                      ? <Duration id={track.id} isFullTrack={(isSubscribed && (track.is_available_for_streaming && !track.pre_order))} previewStartMs={track.sample_start_ms} /> 
                      : `0:00` 
                    }
                  </span> 
                  <span> / { track.length }</span>
                </div>
              </div>
              <div className={`flexRow space-between type-small cf-container-artists`}>
                <div className={`cf-artists`}>
                  {track.artists.map( (a, i) => (
                    <JoinLinkage key={a.id} label={`${a.name}`} separator={(i !== 0) ? `, ` : ``} to={`/artists/${a.slug}/${a.id}`} className={`link-enable`} />
                  ))}
                  {` • `}
                  <Linkage label={track.label} to={`/labels/${track.label_slug}/${track.label_id}`} linkClassName={`link-enable`} />
                  {` • `}
                  <Linkage label={track.genre.name} to={`/genres/${track.genre.slug}/featured`} linkClassName={`link-enable`} />
                </div>
                <span className={`cf-key`}>{ track.key_camelot }</span>
              </div>
            </div>
            <div className={`cf-waveform`}>
              { (playlists.active === i || active === i) && 
                  <Waveform key={`w-${track.id}`} id={track.id} index={i} src={track.waveform}
                    active={(playlists.active === i)} selected={active === i} duration={track.length_s} 
                    baseStart={(isSubscribed && (track.is_available_for_streaming && !track.pre_order)) ? 0 : track.sample_start_ms / 1000} 
                    baseEnd={(isSubscribed && (track.is_available_for_streaming && !track.pre_order)) ? track.length_s : track.sample_end_ms / 1000} 
                    onNext={clickItem(i + 1)} />
              }
            </div>
          </div>
        </div>
      ) ) }
    </Coverflow>
  )
}

ConnectedCoverFlowContainer.propTypes = {
  playlists: PropTypes.any,
  active: PropTypes.number,
  clickItem: PropTypes.func,
  coverFlowStyle: PropTypes.object,
  isSubscribed: PropTypes.bool,
}

const CoverFlowContainer = connect(
  state => ({
    isSubscribed: state.isSubscribed
  }),
)(ConnectedCoverFlowContainer);

export default CoverFlowContainer;
